import { Component, Input } from '@angular/core';
import { ProductSku } from '@models/product';
import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';

/**
 * @deprecated
 * Legacy component still used within ProductsComponent.
 * 
 * Once ZBP-13631 is played and overhauls the ProductsComponent, this could likely be deleted.
 */
@Component({
  selector: 'zbp-license-expired-pop-over',
  templateUrl: './license-expired-pop-over.component.html',
  styleUrls: ['./license-expired-pop-over.component.scss'],
  standalone: false
})
export class LicenseExpiredPopOverComponent {
  @Input() license: ProductSku;
  @Input() placement: string = 'left';
  @Input() container: string = 'body';
  @Input() activationTrigger: string = 'manual';


  open(event: any, popover: NgbPopover) {
    popover.open();
    const el = document.getElementById('licensePopover') as HTMLElement;
    if (el) {
      document.getElementById('licensePopover').focus();
    }
    event.stopPropagation();
  }

  close(event: any, popover: NgbPopover) {
    popover.close();
    event.stopPropagation();
  }

}
